import NetworkConnectionService from 'external-services/network-connection-service/index';
import PreAuthService from "app/services/preauth/preauth.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import BookingChangeService from "external-services/booking-change-service/bookingChange.service";
import { BookingStateChangeTypes } from "shared-types/index";
import StaffService from 'external-services/staff-service/staff.service';

const NS = 'PreAuthDialogCtrl';

export default function PreAuthDialogCtrl(
  $scope, $mdDialog, booking, currencySymbol, currencyCode
) {
  "ngInject";

  const vm = this;

  vm.VIEW = 0;
  vm.LOADING = 1;
  vm.ERROR = 2;
  vm.OFFLINE = 4;
  vm.RELEASED = 5;
  vm.CHARGED = 6;
  vm.state = vm.VIEW;
  vm.currencySymbol = currencySymbol;
  vm.currencyCode = currencyCode;
  vm.booking = booking;
  vm.chargeAmount = Number(vm.booking.paymentSummary.amountDue.toFixed(2));

  vm.close = close;
  vm.charge = charge;
  vm.release = release;

  // settings
  GeneralSettingsService.get().then(function (settings) {
    vm.staffEditEnabled = (settings.staffEditEnabled) ? true : false;
    // vm.staffEditRequired = (settings.staffEditRequired && vm.staffEditEnabled) ? settings.staffEdit.staffEditPaymentBOEdit : false;
    vm.staffEditRequired = StaffService.checkValidityForStaffName(settings.staffEditRequired, vm.staffEditEnabled, settings.staffEdit, settings.staffEdit?.staffEditPaymentBOEdit);
  });

  function close() {
    $mdDialog.hide();
  }

  function release() {
    updatePreAuth(0);
  }

  function charge() {
    updatePreAuth(vm.chargeAmount);
  }

  function updatePreAuth(amount) {

    // Guard online status
    if (!NetworkConnectionService.isOnline()) {
      vm.state = vm.OFFLINE;
      return;
    }

    if (!vm.staffName && vm.staffEditRequired) {
      vm.preAuthForm.staffName.$setTouched();
      return;
    }

    vm.state = vm.LOADING;
    PreAuthService.charge(vm.booking, amount).then(function () {
      let changeType;
      if (amount) {
        vm.state = vm.CHARGED;
        changeType = BookingStateChangeTypes.PRE_AUTH_CHARGED;
      } else {
        vm.state = vm.RELEASED;
        changeType = BookingStateChangeTypes.PRE_AUTH_RELEASED;
      }
      // Track booking changes
      BookingChangeService.saveBookingChange(changeType, vm.booking, null, vm.staffName, amount, `${NS}.updatePreAuth`);
    }).catch(function (err) {
      console.error(err);
      vm.errorMsg = (err && err.data && err.data.message) ? err.data.message : '';
      vm.state = vm.ERROR;
    });
  }
}
